import React from 'react';

import { Empty, Flex, Typography } from 'antd';

interface IProps {
  title: string;
  text: string;
}

export const OrdersEmpty: React.FC<IProps> = ({ title, text }) => (
  <Empty
    image={Empty.PRESENTED_IMAGE_SIMPLE}
    style={{ padding: '48px 0' }}
    description={
      <Flex vertical gap={4} align="center">
        <Typography.Text strong>{title}</Typography.Text>
        <Typography.Text type="secondary">{text}</Typography.Text>
      </Flex>
    }
  />
);
